import React, { createContext, useContext, useState, useEffect } from "react";
import { settingsAPI } from "../services/api";
import { refreshEmitter } from "../hooks/useDataRefresh";

const SiteSettingsContext = createContext(null);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = () => {
    settingsAPI
      .get()
      .then((res) => {
        const s = res.data?.data?.settings || null;
        setSettings(s);
      })
      .catch(() => {
        // silently fall back to null; every consumer provides its own default
        setSettings(null);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchSettings();
    refreshEmitter.on("siteSettings", fetchSettings);
    return () => {
      refreshEmitter.off("siteSettings", fetchSettings);
    };
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refreshSettings: fetchSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

/** Convenience hook */
export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
